<div class="branding center-contents-h font-size-small font-family-bardic-sans">
    <span class="powered-by">
    Powered by
    </span>
    <span class="bt-tagline">The Best RPG Soundboard</span>
    <a class="logo" href="/landing?utm_source=calculator">
        <img
            class="header-logo"
            src="/public/img/bardic-tools-logo.webp"
            alt="Bardic Tools logo"
        />
    </a>
</div>
